export const SET_LOADING = 'SET_LOADING';
export const SET_BUYBOX_MATCHED_PROPERTIES = 'SET_BUYBOX_MATCHED_PROPERTIES';
export const SET_MATCHING_COUNT_SHOWN = 'SET_MATCHING_COUNT_SHOWN';
